(() => {
  'use strict';

  const DEFAULT_CONFIG = {
    slots: {
      morning: {
        label: 'Morning event',
        minTime: '09:00',
        maxTime: '14:00'
      },

      afternoon: {
        label: 'Afternoon / evening event',
        minTime: '15:00',
        maxTime: '22:00'
      }
    },

    /*
     * Inserisci qui eventuali giornate
     * completamente non disponibili.
     *
     * Formato: YYYY-MM-DD
     */
    blockedDates: [],

    /*
     * Qui puoi bloccare soltanto una fascia.
     *
     * Esempio:
     *
     * '2026-08-25': ['morning']
     *
     * blocca la mattina ma lascia libero
     * il pomeriggio.
     */
    blockedSlots: {}
  };

  const getConfig = () => {
  const customConfig =
    window.DOLOBITES_CALENDAR_CONFIG || {};

  const metaobjectBlocks =
    Array.isArray(window.DOLOBITES_CALENDAR_BLOCKS)
      ? window.DOLOBITES_CALENDAR_BLOCKS
      : [];

  const blockedDates = [];
  const blockedSlots = {};

  metaobjectBlocks.forEach((block) => {
    if (!block || !block.date) {
      return;
    }

    const status =
      String(block.status || 'confirmed')
        .trim()
        .toLowerCase();

    /*
     * Le voci Cancelled non bloccano
     * il calendario.
     */
    if (status === 'cancelled') {
      return;
    }

    const slot =
      String(block.slot || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_');

    if (slot === 'full_day') {
      if (!blockedDates.includes(block.date)) {
        blockedDates.push(block.date);
      }

      return;
    }

    if (
      slot !== 'morning' &&
      slot !== 'afternoon'
    ) {
      console.warn(
        'Unknown Dolobites calendar slot:',
        block
      );

      return;
    }

    if (!blockedSlots[block.date]) {
      blockedSlots[block.date] = [];
    }

    if (
      !blockedSlots[block.date].includes(slot)
    ) {
      blockedSlots[block.date].push(slot);
    }
  });

  /*
   * Se per la stessa giornata risultano
   * bloccate entrambe le fasce, la giornata
   * diventa completamente indisponibile.
   */
  Object.entries(blockedSlots).forEach(
    ([date, slots]) => {
      const morningBlocked =
        slots.includes('morning');

      const afternoonBlocked =
        slots.includes('afternoon');

      if (
        morningBlocked &&
        afternoonBlocked &&
        !blockedDates.includes(date)
      ) {
        blockedDates.push(date);
      }
    }
  );

  return {
    ...DEFAULT_CONFIG,
    ...customConfig,

    slots: {
      ...DEFAULT_CONFIG.slots,
      ...(customConfig.slots || {})
    },

    blockedDates: [
      ...new Set([
        ...DEFAULT_CONFIG.blockedDates,
        ...blockedDates,
        ...(Array.isArray(customConfig.blockedDates)
          ? customConfig.blockedDates
          : [])
      ])
    ],

    blockedSlots: {
      ...DEFAULT_CONFIG.blockedSlots,
      ...blockedSlots,
      ...(customConfig.blockedSlots || {})
    }
  };
};

  class DolobitesCalendarV3 {
    constructor(booking) {
      this.booking = booking;
      this.config = getConfig();

      this.dateInput =
        booking.querySelector('#db-event-date');

      this.slotSection =
        booking.querySelector(
          '#db-time-slot-section'
        );

      this.slotButtons =
        Array.from(
          booking.querySelectorAll(
            '[data-time-slot]'
          )
        );

      this.slotMessage =
        booking.querySelector(
          '#db-time-slot-message'
        );

      this.timeSection =
        booking.querySelector(
          '#db-event-time-section'
        );

      this.timeInput =
        booking.querySelector(
          '#db-event-time'
        );

      this.continueButton =
        booking.querySelector(
          '[data-step="1"] [data-next-step="2"]'
        );

      this.selectedSlot = '';
    }

    init() {
      if (
        !this.dateInput ||
        !this.slotSection ||
        !this.timeSection ||
        !this.timeInput ||
        !this.continueButton
      ) {
        console.error(
          'Dolobites calendar markup is incomplete.'
        );

        return;
      }

      this.continueButton.disabled = true;

      this.dateInput.addEventListener(
        'change',
        () => {
          this.handleDateChange();
        }
      );

      this.dateInput.addEventListener(
        'input',
        () => {
          this.handleDateChange();
        }
      );

      this.slotButtons.forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.handleSlotSelection(button);
          }
        );
      });

      this.timeInput.addEventListener(
        'input',
        () => {
          this.validateSelection();
        }
      );

      this.timeInput.addEventListener(
        'change',
        () => {
          this.validateSelection();
        }
      );

      this.resetSelection();

      if (this.dateInput.value) {
        this.handleDateChange();
      }
    }

    handleDateChange() {
      const date =
        this.dateInput.value;

      this.resetSlotAndTime();

      if (!date) {
        this.slotSection.hidden = true;
        this.continueButton.disabled = true;

        this.clearCalendarState();

        return;
      }

      if (this.isDateBlocked(date)) {
        this.slotSection.hidden = false;

        this.disableAllSlots();

        this.showMessage(
          'This date is not available. Please select another date.',
          'error'
        );

        this.continueButton.disabled = true;

        this.clearCalendarState();

        return;
      }

      this.slotSection.hidden = false;

      this.updateSlotAvailability(date);

      const availableSlots =
        this.getAvailableSlots(date);

      if (availableSlots.length === 0) {
        this.showMessage(
          'This date is fully booked. Please select another date.',
          'error'
        );

        this.continueButton.disabled = true;

        this.clearCalendarState();

        return;
      }

      if (availableSlots.length === 1) {
        this.showMessage(
          'Only one time slot is available on this date.',
          'neutral'
        );
      } else {
        this.showMessage(
          'Select an available time slot.',
          'neutral'
        );
      }

      this.continueButton.disabled = true;

      this.emitChange();
    }

    handleSlotSelection(button) {
  if (
    button.disabled ||
    button.getAttribute('aria-disabled') === 'true'
  ) {
    return;
  }

  const slot = button.dataset.timeSlot;
  const slotConfig = this.config.slots[slot];

  if (!slotConfig) {
    return;
  }

  this.selectedSlot = slot;

  this.slotButtons.forEach((slotButton) => {
    const selected = slotButton === button;

    slotButton.classList.toggle(
      'is-selected',
      selected
    );

    slotButton.setAttribute(
      'aria-pressed',
      String(selected)
    );
  });

  this.populateTimeOptions(
    slotConfig.minTime,
    slotConfig.maxTime
  );

  this.timeSection.hidden = false;

  this.showMessage(
    `${slotConfig.label} selected. Choose the exact start time.`,
    'success'
  );

  this.continueButton.disabled = true;

  this.emitChange();
}
populateTimeOptions(minTime, maxTime) {
  this.timeInput.innerHTML = '';

  const placeholder =
    document.createElement('option');

  placeholder.value = '';
  placeholder.textContent =
    'Select a start time';

  this.timeInput.appendChild(
    placeholder
  );

  const startMinutes =
    this.timeToMinutes(minTime);

  const endMinutes =
    this.timeToMinutes(maxTime);

  for (
    let minutes = startMinutes;
    minutes <= endMinutes;
    minutes += 30
  ) {
    const value =
      this.minutesToTime(minutes);

    const option =
      document.createElement('option');

    option.value = value;
    option.textContent =
      this.formatTime(value);

    this.timeInput.appendChild(
      option
    );
  }

  this.timeInput.value = '';
}

timeToMinutes(time) {
  const [hours, minutes] =
    time.split(':').map(Number);

  return (
    hours * 60 +
    minutes
  );
}

minutesToTime(totalMinutes) {
  const hours =
    Math.floor(totalMinutes / 60);

  const minutes =
    totalMinutes % 60;

  return (
    `${String(hours).padStart(2, '0')}:` +
    `${String(minutes).padStart(2, '0')}`
  );
}
    validateSelection() {
      const date =
        this.dateInput.value;

      const time =
        this.timeInput.value;

      const slot =
        this.selectedSlot;

      const slotConfig =
        this.config.slots[slot];

      if (
        !date ||
        !slot ||
        !time ||
        !slotConfig
      ) {
        this.continueButton.disabled = true;

        this.emitChange();

        return false;
      }

      const isTimeValid =
        time >= slotConfig.minTime &&
        time <= slotConfig.maxTime;

      if (!isTimeValid) {
        this.continueButton.disabled = true;

        this.showMessage(
          `Please choose a time between ` +
            `${this.formatTime(slotConfig.minTime)} and ` +
            `${this.formatTime(slotConfig.maxTime)}.`,
          'error'
        );

        this.clearCalendarState();

        return false;
      }

      if (
        this.isSlotBlocked(
          date,
          slot
        )
      ) {
        this.continueButton.disabled = true;

        this.showMessage(
          'This time slot is no longer available.',
          'error'
        );

        this.clearCalendarState();

        return false;
      }

      const calendarState = {
        date,
        slot,
        slotLabel:
          slotConfig.label,
        time,
        formattedTime:
          this.formatTime(time),
        available: true
      };

      window.DOLOBITES_V3_CALENDAR =
        calendarState;

      this.continueButton.disabled =
        false;

      this.showMessage(
        `${slotConfig.label} confirmed for ` +
          `${this.formatTime(time)}.`,
        'success'
      );

      this.emitChange(
        calendarState
      );

      return true;
    }

    updateSlotAvailability(date) {
      this.slotButtons.forEach(
        (button) => {
          const slot =
            button.dataset.timeSlot;

          const blocked =
            this.isSlotBlocked(
              date,
              slot
            );

          button.disabled = blocked;

          button.setAttribute(
            'aria-disabled',
            String(blocked)
          );

          button.classList.toggle(
            'is-unavailable',
            blocked
          );

          button.classList.remove(
            'is-selected'
          );

          button.setAttribute(
            'aria-pressed',
            'false'
          );

          const existingStatus =
            button.querySelector(
              '.db-booking__time-slot-status'
            );

          if (existingStatus) {
            existingStatus.remove();
          }

          if (blocked) {
            const status =
              document.createElement(
                'span'
              );

            status.className =
              'db-booking__time-slot-status';

            status.textContent =
              'Unavailable';

            button.appendChild(status);
          }
        }
      );
    }

    disableAllSlots() {
      this.slotButtons.forEach(
        (button) => {
          button.disabled = true;

          button.setAttribute(
            'aria-disabled',
            'true'
          );

          button.classList.add(
            'is-unavailable'
          );

          button.classList.remove(
            'is-selected'
          );

          button.setAttribute(
            'aria-pressed',
            'false'
          );
        }
      );
    }

    getAvailableSlots(date) {
      return Object.keys(
        this.config.slots
      ).filter(
        (slot) =>
          !this.isSlotBlocked(
            date,
            slot
          )
      );
    }

    isDateBlocked(date) {
      return this.config
        .blockedDates
        .includes(date);
    }

    isSlotBlocked(
      date,
      slot
    ) {
      const blockedSlots =
        this.config
          .blockedSlots[date] || [];

      return blockedSlots.includes(
        slot
      );
    }

    resetSelection() {
      this.slotSection.hidden = true;
      this.timeSection.hidden = true;
      this.continueButton.disabled = true;

      this.resetSlotAndTime();
      this.clearCalendarState();
    }

    resetSlotAndTime() {
      this.selectedSlot = '';

      this.timeInput.innerHTML = `
  <option value="">
    Select a start time
  </option>
`;

this.timeInput.value = '';

      this.timeSection.hidden = true;

      this.slotButtons.forEach(
        (button) => {
          button.classList.remove(
            'is-selected',
            'is-unavailable'
          );

          button.disabled = false;

          button.setAttribute(
            'aria-pressed',
            'false'
          );

          button.setAttribute(
            'aria-disabled',
            'false'
          );

          const existingStatus =
            button.querySelector(
              '.db-booking__time-slot-status'
            );

          if (existingStatus) {
            existingStatus.remove();
          }
        }
      );

      this.continueButton.disabled = true;
    }

    clearCalendarState() {
      window.DOLOBITES_V3_CALENDAR =
        null;
    }

    showMessage(
      message,
      type = 'neutral'
    ) {
      if (!this.slotMessage) {
        return;
      }

      this.slotMessage.textContent =
        message;

      this.slotMessage.classList.remove(
        'is-neutral',
        'is-success',
        'is-error'
      );

      this.slotMessage.classList.add(
        `is-${type}`
      );
    }

    formatTime(time) {
      if (!time) {
        return '';
      }

      const [
        hoursString,
        minutesString
      ] = time.split(':');

      const hours =
        Number(hoursString);

      const minutes =
        Number(minutesString);

      if (
        !Number.isFinite(hours) ||
        !Number.isFinite(minutes)
      ) {
        return time;
      }

      const suffix =
        hours >= 12
          ? 'PM'
          : 'AM';

      const displayHours =
        hours % 12 || 12;

      return (
        `${displayHours}:` +
        `${String(minutes).padStart(2, '0')} ` +
        suffix
      );
    }

    emitChange(
      detail =
        window.DOLOBITES_V3_CALENDAR
    ) {
      document.dispatchEvent(
        new CustomEvent(
          'dolobites:calendar-change',
          {
            detail
          }
        )
      );
    }
  }

  const initializeCalendar = (
    root = document
  ) => {
    const bookings =
      Array.from(
        root.querySelectorAll(
          '.db-booking'
        )
      );

    bookings.forEach(
      (booking) => {
        if (
          booking.dataset
            .calendarV3Initialized ===
          'true'
        ) {
          return;
        }

        booking.dataset
          .calendarV3Initialized =
          'true';

        const calendar =
          new DolobitesCalendarV3(
            booking
          );

        booking.dolobitesCalendarV3 =
          calendar;

        calendar.init();
      }
    );
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeCalendar();
      }
    );
  } else {
    initializeCalendar();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeCalendar(
        event.target || document
      );
    }
  );
})();